<template>
  <Modal title="Reset to staged" :max-width="480" @close="$emit('close')">
    <div class="resetStagedBody">
      <p class="resetStagedIntro">
        {{ count }} candidate{{ count !== 1 ? 's' : '' }} will be moved back to
        the staged queue for re-qualification. Active sequence enrollments will be exited and any
        reachouts pending approval will be deleted.
      </p>
      <label class="resetStagedField">
        <span>Reason <span class="resetStagedOptional">(optional)</span></span>
        <textarea v-model="notes" class="resetStagedTextarea" rows="2" placeholder="e.g. Added a new qualification block, need to re-evaluate…" />
      </label>
    </div>
    <template #footer>
      <button class="btn secondary" @click="$emit('close')">Cancel</button>
      <button class="btn primary" :disabled="busy" @click="$emit('confirm', notes.trim() || null)">
        {{ busy ? 'Resetting…' : 'Reset to staged' }}
      </button>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import Modal from './Modal.vue'

defineProps<{
  count: number
  busy: boolean
}>()

defineEmits<{
  close: []
  confirm: [notes: string | null]
}>()

const notes = ref('')
</script>

<style scoped>
.resetStagedBody {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}
.resetStagedIntro {
  margin: 0;
  font-family: var(--font-sans);
  font-size: var(--fs-sm);
  color: var(--color-text-secondary);
  line-height: var(--lh-normal);
}
.resetStagedField {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}
.resetStagedField > span {
  font-family: var(--font-sans);
  font-size: var(--fs-xs);
  font-weight: var(--fw-semibold);
  color: var(--color-text-secondary);
  text-transform: uppercase;
  letter-spacing: var(--tracking-wide);
}
.resetStagedOptional {
  font-weight: var(--fw-regular);
  color: var(--color-text-tertiary);
  text-transform: none;
  letter-spacing: normal;
}
.resetStagedTextarea {
  width: 100%;
  resize: vertical;
  padding: var(--space-2);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
  font-family: var(--font-sans);
  font-size: var(--fs-sm);
  color: var(--color-text-primary);
}
</style>
